import { AnimatePresence, motion } from 'motion/react';
import Image from 'next/image';
import infoIcon from 'public/img/toast-icon-info.svg';
import { useImperativeHandle, useState } from 'react';

import { iconStyle, textStyle, toastStyle } from './Toast.css';

type Type = 'black';

type Size = 'mini';

export interface ToastRef {
  show: (milliseconds: number) => void;
}

export interface ToastProps {
  type: Type;
  size: Size;
  text: string;
}

export const Toast = ({
  ref,
  type,
  size,
  text,
}: ToastProps & {
  ref?: React.Ref<ToastRef>;
}) => {
  const [visible, setVisible] = useState(false);

  useImperativeHandle(ref, () => ({
    show: (milliseconds: number) => {
      setVisible(true);
      setTimeout(() => setVisible(false), milliseconds);
    },
  }));

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className={toastStyle({ type, size })}
          initial={{ y: '-6rem' }}
          animate={{
            y: 0,
            transition: { ease: 'easeOut', duration: 0.3 },
          }}
          exit={{
            y: '-5rem',
            transition: { ease: 'easeOut', duration: 0.3 },
          }}
        >
          <Image src={infoIcon} alt="info icon" className={iconStyle}></Image>
          <span className={textStyle}>{text}</span>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

Toast.displayName = 'Toast';
